var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 154,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 30.832c0-16.568 13.431-30 30-30h75c16.569 0 30 13.432 30 30v43a5 5 0 0 1-5 5H23a5 5 0 0 1-5-5v-43Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30.832c0-16.568 13.431-30 30-30 16.569 0 30 13.432 30 30v48H18v-48Z",
    fill: "#B8B8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.833a5 5 0 0 1 5-5h41v43H37a5 5 0 0 1-5-5v-33Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 56.833a2 2 0 0 1 2-2h17v4H61a2 2 0 0 1-2-2Z",
    fill: "#D2D9E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37.833a2 2 0 0 1 2-2h15a2 2 0 0 1 0 4H41a2 2 0 0 1-2-2Z",
    fill: "#778CB8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 44.833a2 2 0 0 1 2-2h15a2 2 0 0 1 0 4H41a2 2 0 0 1-2-2ZM59 64.832a2 2 0 0 1 2-2h17v4H61a2 2 0 0 1-2-2Z",
    fill: "#D2D9E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 .833c-1.07 0-2.127.056-3.169.165C56.752 2.399 66 12.536 66 24.833v54h12v-48c0-16.569-13.432-30-30-30Z",
    fill: "#9C9C9C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 81.832a5 5 0 0 0 5 5h68a5 5 0 0 0 5-5v-3H0v3Z",
    fill: "#F2F2F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 11.832,
    width: 4,
    height: 33,
    rx: 2,
    fill: "#DEDEDE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102 13.832h15l-5 5 5 5h-15v-10Z",
    fill: "#4965A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M84 78.832h5v75h-5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8B8",
    d: "M89 78.832h9v75h-9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C9C9C",
    fillOpacity: 0.3,
    d: "M84 78.832h14v8H84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsEmpty);
export default __webpack_public_path__ + "static/media/notifications_empty.a62d7cdebffe2ed854bc2744c541bdc8.svg";
export { ForwardRef as ReactComponent };